exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@media (min-width: 767px) and (max-width: 1024px) {\n  .font-12 {\n    font-size: 12px !important; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/tnt_control/component/shiptype/create/shiptype.create.scss
// module id = 1174
// module chunks = 1